'use client';
import Image from 'next/image';
import Slider from 'react-slick';
import './styles.css';

const settings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: 'carousel-dots',
};

type Props = {
  items: {
    title: string;
    body: string;
  }[];
};

type CarouselItemProps = {
  item: {
    title: string;
    body: string;
  };
  imgSrc: string;
};

export default function WhyChooseUsCarousel({ items }: Props) {
  const featureIcons = [
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/features-quality@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/features-service@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/protection@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/peace-of-mind@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/guarantee@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/travel-pack@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/features-team@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/features-pack@3x.png',
    'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/features/features-services@3x.png',
  ];

  return (
    <>
      <div className="hidden lg:flex flex-wrap">
        {items.map((item, index) => (
          <div
            key={index}
            className="w-[calc(100%-1.875rem)] mx-[0.9375rem] desktop:mb-[60px] desktop:w-[calc(33.33333%-1.875rem)]">
            <WhyChooseUsCarouselItem
              key={index}
              item={item}
              imgSrc={featureIcons[index] || featureIcons[0]}
            />
          </div>
        ))}
      </div>
      <Slider className="why-carousel mb-[30px] lg:!hidden" {...settings}>
        {items.map((item, index) => (
          <WhyChooseUsCarouselItem
            key={index}
            item={item}
            imgSrc={featureIcons[index]}
          />
        ))}
      </Slider>
    </>
  );
}

function WhyChooseUsCarouselItem({ imgSrc, item }: CarouselItemProps) {
  return (
    <div className="py-5">
      <div className="text-center relative">
        <Image
          width={64}
          height={64}
          src={imgSrc}
          alt={item.title}
          className="mb-[20px] mx-auto min-h-[64px] align-middle max-w-full"
        />
      </div>
      <h3 className="text-center text-xl font-semibold mb-[10px]">
        {item.title}
      </h3>
      <div className="text-center text-base">{item.body}</div>
    </div>
  );
}
